export const convertYesNoOption = (value: boolean) => {
  return value ? 'Tak' : 'Nie';
}